var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arrows"},[(_vm.isExpanded)?_c('img',{staticClass:"arrows__img",attrs:{"src":_vm.arrowDown,"alt":""}}):_c('img',{staticClass:"arrows__img",attrs:{"src":_vm.arrowRight,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }